<template>
    <div>
      <!--Bikes | Bicicletas -->
      <b-row class="bikes">

        <b-col md="12" lg="6" class="text-center text-sm-left">
          <h5 class="mb-1 mt-3 d-inline-block">Minhas Bicicletas <span v-if="bikes.length">({{bikes.length}})</span></h5>
        </b-col>

         <b-col md="12" lg="6" v-if="thePhoneIsVerified">
            <div v-if="this.$store.state.user.data.bikes.length">
               <span v-if="registerStatus" class="text-center text-sm-right">

                   <el-button
                      v-if="nBikes"
                      @click="firstNewBike()"
                      type="primary"
                      size="mini"
                      class="text-uppercase d-block font-weight-bold mb-2 pl-5 pr-5 mt-2 ml-auto mr-auto"
                      round>
                     + Adicionar nova Bicicleta
                   </el-button>

                   <el-button
                      v-else
                      type="primary"
                      size="mini"
                      class="text-uppercase font-weight-bold mb-2 pl-5 pr-5 mt-2 ml-auto"
                      round>
                     Você só pode Cadastrar {{numberOfBikes()}} Bikes no momento!
                   </el-button>
               </span>
            </div>


            <div class="font-weight-bold">
               <el-alert
                  v-if="!nBikes && user.additionalInformation.type !== 'pj'"
                  title="Considere fazer um cadastro de pessoa jurídica na plataforma Pedale. Entre em conato via chat!"
                  type="info"
                  show-icon
                  :closable="false"
               >
               </el-alert>
            </div>
         </b-col>

        <b-col cols="12" v-if="user._id && !loading && (showBanner || !showBannerBieks)">
            <WelcomePanelBanner
               :user="user"
               :title="`Olá ${currentUser.user.firstName}, vamos ajudar as pessoas a terem experiências inesquecíveis?`"
               desc="Cadastre agora mesmo a sua primeira bike. É fácil, rápido, seguro e ainda muito rentável."
               :background="bgNoBikes"
               col_xl="8"
               col_lg="12"
               col_md="12"
               link="/nova-bicicleta"
               textLink="Clique aqui para cadastrar sua bike"
               :userIsReady="userIsReady"
               :userHasBankAccount="userHasBankAccount"
               :userHasDigitalAccount="userHasDigitalAccount"
               :approvedDigitalAccount="approvedDigitalAccount"
            />
         </b-col>

        <b-col cols="12">
           <b-row>
              <b-col v-for="(bike, index) in bikes" :key="index" sm="12" lg="6" xl="4" class="mb-4 mb-xl-0 mt-4 status" :class="getBikeStatus(bike.status).type">

                 <el-button
                    @click="removeBike(bike._id)"
                    class="btnDelBike"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    title="Remover"></el-button>


                 <el-button
                    v-if="(bike.status === 1 || bike.status === 4) && currentUser.user.type === 'master'"
                    @click="changeStatus(2, bike._id)"
                    class="btnDelBike"
                    type="info"
                    style="margin-top: 50px"
                    icon="el-icon-check"
                    circle
                    title="Aprovar"></el-button>

                 <el-button
                    v-if="(bike.status === 1 || bike.status === 2) && currentUser.user.type === 'master'"
                    @click="changeStatus(4, bike._id)"
                    class="btnDelBike"
                    type="warning"
                    :style="bike.status === 2 ? 'margin-top: 50px' : 'margin-top: 100px'"
                    icon="el-icon-close"
                    circle
                    title="Rejeitar"></el-button>

                 <b-badge :class="getBikeStatus(bike.status).type">
                    {{ getBikeStatus(bike.status).message }}</b-badge>
                 <b-card
                    :title="bike.name"
                    tag="article"
                    class="mb-4 thumb-bike ml-auto mr-auto"
                    align="center"
                    title-tag="h2"
                 >

                    <b-card-text>
                       <el-image
                          @click="fixRelativeBody"
                          style="width: 100%; height: 150px"
                          class="mb-2"
                          :src="getCover((!bike.coverPhoto ? null : bike.coverPhoto))"
                          fit="cover"></el-image>
                       <span class="text-muted price">Valor da diária: R$ {{bike.dailyValue}}</span>
                       <div class="mt-2">
                          <el-rate
                             v-model="bike.rateMetrics.averageRating"
                             disabled
                             show-score
                             text-color="#ff9900"
                             score-template="{value}"
                          >
                          </el-rate>
                          <small class="text-small" style="color: #ff9900">
                             {{ bike.rateMetrics.totalRatings === 1 ?
                             bike.rateMetrics.totalRatings + ' avaliação' :
                             bike.rateMetrics.totalRatings > 1 ?
                                bike.rateMetrics.totalRatings + ' avaliações' : 'Nenhuma avaliação'
                             }}</small>
                       </div>
                    </b-card-text>
                    <b-row>
                       <b-col cols="12" sm="6" class="mb-3">
                          <el-button
                             v-if="thePhoneIsVerified"
                             type="primary"
                             @click="$router.push(`/painel/anunciante/minhas-bicicletas/bicicleta/info/${bike._id}`)"
                             size="mini" class="text-uppercase w-100"
                             round>
                             Editar
                          </el-button>
                       </b-col>
                       <b-col cols="12" sm="6">
                          <el-button
                             type="primary"
                             @click="$router.push(`/bicicleta/${bike.slug}`)"
                             size="mini" class="text-uppercase bg-transparent text-primary w-100"
                             round>
                             Ver
                          </el-button>
                       </b-col>
                    </b-row>


                 </b-card>
              </b-col>
           </b-row>
        </b-col>

      </b-row>


    </div>
</template>

<script>
    import noImgBike from '@/assets/img/no-bike.jpg';
    import BikeService from '@/services/bike.service';
    import WelcomePanelBanner from "@/components/WelcomePanelBanner";
    import bgNoBikes from '@/assets/img/bg-cadastro-bike.svg';
    import BikeImg from '@/helpers/GetBikeCover'
    import UserService from "@/services/user.service";
    import Permission from "@/helpers/Permission";
    import {handleSendFirstNewBike} from "@/helpers/handleSendFirstNewBike";
    import {BCard, BCardText, BBadge} from "bootstrap-vue";

    export default {
    name: 'Overview',
    components: {
      WelcomePanelBanner,
       BCard,
       BCardText,
       BBadge
    },
    directives: {
       'b-card': BCard,
       'b-card-text': BCardText,
       'b-badge': BBadge,
    },
    data() {
        return {
            noImgBike,
            bgNoBikes,
            bikes: [],
            baseUrl: process.env.VUE_APP_BASE_URL,
            apiV1: process.env.VUE_APP_API_V1,
            loading: true,
            showBanner: false,
            user: {},
            userIsReady: false,
            userHasBankAccount: false,
            userHasDigitalAccount: false,
            userHasDocs: true,
            approvedDigitalAccount: false,
            registerOk: false,
            thePhoneIsVerified: null,
            numberOfBikes: () => this.isPJ ? 1000 : 500
        }
    },
    async mounted() {
       await this.getBikes();
       await this.getUser();
       this.user = this.userData

       if (this.user._id) {

          const checkUser = new Permission(this.user)

          this.userIsReady = checkUser.userIsReady()

          this.userHasBankAccount = true

          this.userHasDigitalAccount = true

          this.approvedDigitalAccount = true

          this.registerOk = this.userIsReady && this.userHasBankAccount  &&  this.approvedDigitalAccount

          this.thePhoneIsVerified = checkUser.thePhoneIsVerified()

          if (!checkUser.thePhoneIsVerified() ) {
             await this.$router.push({name: 'profile', params: { verifiedPhone: false } })
          }

          await this.$store.dispatch("user/registerStatus", this.registerOk )
       }

    },

    methods: {

       async getUser() {
          await this.$store.dispatch('user/get', await UserService.getUserData())
       },

       firstNewBike() {
          handleSendFirstNewBike(this.user, this.userIsReady, this.userHasBankAccount)
       },

       async getBikes() {
          const loading = this.$loading({
             fullscreen: false,
             target: '.bikes',
             lock: true,
             text: 'Carregando...',
             spinner: 'el-icon-loading',
             background: 'rgba(255, 255, 255, 0.7)'
          });
            await BikeService.getUserBikes().then(
                response => {
                    setTimeout(() => {
                       this.loading = false
                       loading.close();
                       this.bikes = response.data.data;
                       this.$store.dispatch('bike/query', this.bikes.length);
                       this.showBanner = !this.bikes.length || false
                    }, 1000)
                    },
                err => {
                    this.$message.error(err.response.data.message);
                    this.$loading().close();
                }
            );
        },

        getCover(uri) {
            return BikeImg.getCover(uri);
        },

        getBikeStatus(s) {

          if (s) {
            let status = {};

            switch (s) {
              case 1:
                status.type = 'review';
                status.message = 'EM ANÁLISE';
                break;
              case 2:
                status.type = 'approved';
                status.message = 'DISPONÍVEL';
                break;
              case 3:
                status.type = 'rent';
                status.message = 'ALUGADA';
                break;
              case 4:
                status.type = 'disapprove';
                status.message = 'REPROVADA';
                break;
              default:
                status.type = null;
                status.message = null;
            }

            return status;
          }



        },

        fixRelativeBody() {
            let body = document.querySelector("body");
            body.style.overflow = 'visible';
        },

        removeBike(_id) {
            this.$confirm('Você tem certeza que deseja excluir esta bicicleta?', 'Atenção', {
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                type: 'warning'
            }).then(() => {
                BikeService.deleteBike(_id).then(
                    response => {
                        this.$message.success(response.data.message);
                        this.bikes = this.bikes.filter(e => !Object.values(e).includes(_id));
                    },
                    err => {
                        this.$message.error(err.response.data.message);
                    }
                );
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Ufa, essa foi por pouco!'
                });
            });
        },

        async changeStatus(status, bikeId) {
          try {
            const data = { status, bikeId  }
            await BikeService.statusBike(data)
              .then((response) => {
                if (response.data.data) {
                  this.getBikes()
                  this.$message.success("Status da bicicleta alterado com sucesso!");
                }
              })
              .catch(err => {
                this.$message.error(err);
              });

          } catch (e) {
            new Error(e)
          }


        },

       checkDocsStatus(docs) {
          if (docs) {
             const allApproved = docs.map(f => f.approvalStatus === 'APPROVED' ).every(Boolean)
             const allVerifying = docs.map(f => f.approvalStatus === 'VERIFYING' ).every(Boolean)

             if (allApproved) return 'APPROVED'
             if (allVerifying) return 'VERIFYING'

          }

       }

    },
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
       userData() {
          return this.$store.getters["user/getUserData"]
       },
      showBannerBieks() {
        return this.bikes.length
      },
      nBikes() {
        return this.bikes.length < this.numberOfBikes()
      },
       isPJ() {
          return this.$store.state.user.data.additionalInformation.type === 'pj' || false
       },
       registerStatus() {
          return this.$store.state.user.registerOK;
       },
    }
 };
</script>

<style>
 .bikes {
    min-height: 60vh;
    align-content: baseline;
 }
</style>
